export default __webpack_public_path__ + "static/media/EU-Taxonomy-New.71dbc848.svg";